import { useEffect } from 'react';
import parse from 'html-react-parser';
import { isNullOrEmpty } from '../../../helpers/ObjectHelpers';

export const usePickerItems = (
    canDelete: boolean,
    setItems: (items: any[]) => void,
    value?: Date | null) => {

    useEffect(() => {
        const result = [
            {
                name: parse("N&aring;"),
                event: "now"
            },
            {
                name: "Rediger",
                event: "edit"
            }
        ];
        
        if (!isNullOrEmpty(value) && canDelete) {
            result.push({
                name: "Slett",
                event: "delete"
            })
        }
        setItems(result);        
    }, [value]);
};
